import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CreateProductOrganisationDTO, ImportResponse, OrganisationId, ProductOrganisation, ProductOrganisationSelect, UpdateProductOrganisationDTO } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class ProductsOrganisationApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PRODUCTS_ORG_URL = `${this.apiServer}/product-organisations`;

    getProductOrganisation(organisationId: OrganisationId): Observable<ProductOrganisation[]> {
        return this.http.get<ProductOrganisation[]>(`${this.PRODUCTS_ORG_URL}?organisationId=${organisationId}`);
    }

    getProductOrganisationById(id: string): Observable<ProductOrganisation> {
        const url = `${this.PRODUCTS_ORG_URL}/${id}`;
        return this.http.get<ProductOrganisation>(url);
    }

    createProductOrganisation(productOrgDTO: CreateProductOrganisationDTO): Observable<ProductOrganisation> {
        return this.http.post<ProductOrganisation>(`${this.PRODUCTS_ORG_URL}`, productOrgDTO);
    }

    updateProductOrganisation(productOrganisationDTO: UpdateProductOrganisationDTO): Observable<ProductOrganisation> {
        return this.http.put<ProductOrganisation>(`${this.PRODUCTS_ORG_URL}/${productOrganisationDTO.productOrganisationId}`, productOrganisationDTO);
    }

    attachGlobalProduct(productOrganisationId: number, productId: string): Observable<ProductOrganisation> {
        return this.http.put<ProductOrganisation>(`${this.PRODUCTS_ORG_URL}/${productOrganisationId}/attach-product`, null, {
            params: { productId: productId }
        });
    }

    /* patchProductOrganisation(productOrganisationId: number, params: object): Observable<ProductOrganisation> {
        return this.http.patch<ProductOrganisation>(`${this.PRODUCTS_ORG_URL}/${productOrganisationId}`, params);
    } */

    deleteProductOrganisation(id: string | number): Observable<string | number> {
        return this.http.delete<string | number>(`${this.PRODUCTS_ORG_URL}/${id}`)
            .pipe(map(() => id));
    }

    getProductOrgsForSearchTerm(term: string, orgId: string): Observable<ProductOrganisationSelect[]> {
        return this.http.get<ProductOrganisationSelect[]>(`${this.PRODUCTS_ORG_URL}/select`, {
            params: {
                'supplierRefOrDescription': term,
                'organisationId': orgId
            }
        });
    }

    uploadProductsFile(orgId: string, formData: FormData): Observable<ImportResponse> {
        return this.http.post<ImportResponse>(`${this.apiServer}/import?organisationId=${orgId}`, formData);
    }

    downloadProductsExcel(orgId: string): Observable<HttpResponse<Blob>> {
        return this.http.get<Blob>(`${this.apiServer}/export-products`, {
            params: { 'organisationId': orgId },
            responseType: 'blob' as 'json',
            observe: 'response'
        });
    }
    
    unattachGlobalProduct(productOrganisationId: number): Observable<ProductOrganisation> {
        return this.http.put<ProductOrganisation>(`${this.PRODUCTS_ORG_URL}/${productOrganisationId}/unattach-product`, null);
    }
    //Bulk Approve on Product
    approveProduct(productOrganisationIds: number[]): Observable<string> {
        return this.http.put<string>(`${this.PRODUCTS_ORG_URL}/product-status`, {
            productStatusId: 1,
            productOrganisationIdList: productOrganisationIds
        });
    }
}
